import { useState, useEffect, useRef } from 'react';

export const useDetailConfigLocal = (detailConfig, item) => {
    const [detailConfigLocal, setDetailConfigLocal] = useState(detailConfig);
    const prevItemDataRef = useRef();

    useEffect(() => {
        if (!item?.data || !detailConfig) return;

        // Controlla se i dati sono realmente cambiati
        const currentItemData = JSON.stringify(item.data);
        if (currentItemData === prevItemDataRef.current) return;
        prevItemDataRef.current = currentItemData;

        const newDetailConfigLocal = { ...detailConfig };
        const matchingVehiclesInputElement = newDetailConfigLocal.tabs[0].fieldsets[0].fields.matchingVehicles.relation;

        matchingVehiclesInputElement.filter = {
            items: [
                ...(item.data?.rules ?? []).map((rule) => ({
                    field: rule.field,
                    operator: rule.operator,
                    value: rule.value
                })),
                {
                    field: '_related_renter_name',
                    operator: "equals",
                    value: item.data?.deal?.partner?.name
                },
                {
                    field: '_related_contract_contract_at',
                    operator: "between",
                    value: {
                        from: item.data?.deal?.start_at,
                        to: item.data?.deal?.end_at
                    }
                }
            ]
        };
        matchingVehiclesInputElement.columnsNeeded = [
            "_related_renter_name",
            "_related_contract_contract_at",
            "_related_contract_orderPurchaseType",
            "_related_contract_orderType",
            "_related_contract_orderExtensionType",
            "plate",
            "status",
            "_related_legalEntity_name",
            "_related_legalEntity_commercialCluster",
            "_related_setup_make",
            "_related_setup_model",
            "_related_setup_setup",
            "_related_contract_contractDuration",
            "_related_contract_contractMileage"
        ]

        console.info('Detail di PartnershipRuleset imposto i filtri alla lista veicoli', matchingVehiclesInputElement, item);
        setDetailConfigLocal(newDetailConfigLocal);
    }, [detailConfig, item?.data]); // Dipendenze specifiche

    return { detailConfigLocal };
};